import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import useUser from '@alltrails/context/hooks/useUser';
import logProUpsellFunFactShown from '@alltrails/amplitude/events/logProUpsellFunFactShown';
import { useEffect, useRef } from 'react';
import UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import styles from './FunFact.module.scss';

type Props = {
  upsellTrigger: UpsellTrigger;
};

// https://www.figma.com/design/MC1S4hoaBuQ8gioWWyffhs/Denali-Upsell-System?node-id=1-1927&m=dev
export default function FunFact({ upsellTrigger }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const user = useUser();

  const isPromoEligible = !user || user.isPromoEligible;

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          logProUpsellFunFactShown({
            purchase_screen_type_plan: isPromoEligible ? 'free trial' : 'non trial',
            trigger: upsellTrigger
          });
        }
      });
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [isPromoEligible, ref, upsellTrigger, user]);

  return (
    <div ref={ref}>
      <Typography className={styles.did} variant="text100bold">
        <FormattedMessage defaultMessage="Did you know?" />
      </Typography>
      <div className={styles.fact}>
        <div className={styles.threex}>
          <FormattedMessage defaultMessage="3x" />
        </div>
        <div className={styles.line}></div>
        <Typography variant="text200">
          <FormattedMessage defaultMessage="Subscribers are 3 times more likely to hit the trail" />
        </Typography>
      </div>
    </div>
  );
}
